/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {Alignment} from '../../constants';

const enum FlexAlignment {
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
}

export const getProductOptionsCustomCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {styleParams, isRTL} = customCssVarsFnParams;

  const getProductDetailsFlexAlignment = () => {
    const defaultAlignmentRtl = isRTL ? Alignment.RIGHT : Alignment.LEFT;
    switch (styleParams.strings.productPage_productDetailsAlignment?.value || defaultAlignmentRtl) {
      case Alignment.LEFT:
        return isRTL ? FlexAlignment.FlexEnd : FlexAlignment.FlexStart;
      case Alignment.RIGHT:
        return isRTL ? FlexAlignment.FlexStart : FlexAlignment.FlexEnd;
      case Alignment.CENTER:
        return FlexAlignment.Center;
    }
  };

  const flexAlignment = getProductDetailsFlexAlignment();

  return {
    errorMessageFlexAlignment: flexAlignment,
    productDetailsFlexAlignment: flexAlignment,
  };
};
